<template>
  <div class="aboutDetail">
       <div class="content-width">
            <el-row :gutter="22">
                <!-- 左侧部分 -->
                <el-col :span="18">
                    <el-row>
                        <el-col :span="24" class="r-title">关于我们</el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24" class="r-intro">
                            <div id="container" v-html="content"></div>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </div>
               
  </div>
</template>

<script>
export default {
  name: 'aboutDetail',
  data () {
    return {
        content:"",
    }
  },
  methods:{
         //获得关于我们
        getAboutUs(){
             let that = this;
            let url = "/relevant/getByflag";
            that.$http
                .post(url)
                .then(res => {
                    if (res.data.code == 200) {
                       const str = res.data.data.content;
                       this.content = str;
                        // const paragraphs = str.split('\n\n');
                        // const container = document.getElementById('container');
                        // paragraphs.forEach(paragraph => {
                        // const p = document.createElement('p');
                        // p.textContent = paragraph;
                        // container.appendChild(p);
                        // });
                    } else {
                        that.$message.error(res.data.msg);
                    }
                })
                .catch(() => {
                    that.$message.error("网络错误！");
                });
        },
  },
  created(){
      let that = this;
      that.getAboutUs();
  }
  
}
</script>

<style scoped>
p{
    text-indent: 2em;
}
#container{
    p{
        text-indent: 2em;  
    }
}
</style>



// WEBPACK FOOTER //
// src/components/aboutDetail.vue